import React, { useCallback, memo } from "react";
import { Pagination, PaginationProps } from "semantic-ui-react";

interface TablePaginationProps extends Omit<PaginationProps, "onPageChange"> {
    activePage: number;
    onPageChange: (newPage: number) => void;
    totalPages: number;
}

const TablePagination: React.FC<TablePaginationProps> = ({
    activePage,
    onPageChange,
    totalPages,
    ...ohterProps
}) => {

    const onChangePage = useCallback((_1, { activePage: newPage }) => {
        // <Pagination> uses 1-indexed pages, but we use zero-indexed
        const next = newPage - 1
        if (typeof next === "number") {
            onPageChange(newPage);
        }
    }, [onPageChange]);

    return (
        <Pagination
            activePage={activePage}
            onPageChange={onChangePage}
            totalPages={Math.ceil(totalPages)}
            {...ohterProps}
        />
    );
};

export default memo(TablePagination);
